import AccountTreeIcon from "@mui/icons-material/AccountTree";
import PuzzleIcon from "@mui/icons-material/Extension";
import TourIcon from "@mui/icons-material/Tour";
import { Navigation } from "@toolpad/core";

export const NAVIGATION: Navigation = [
  {
    kind: "header",
    title: "Analytics Dashboard",
  },
  {
    segment: "global-stats",
    title: "Statistiche globali",
    icon: <TourIcon />,
    kind: "page",
  },
  {
    segment: "city-escape",
    title: "City Escape",
    icon: <AccountTreeIcon />,
  },
  {
    segment: "enigmas",
    title: "Enigmi",
    icon: <PuzzleIcon />,
  },
];
